import dayjs from "dayjs";
import React,{ useEffect, useState } from "react";
import { Form } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify";
import Axios from "axios";
import { getRoomRequisitions } from "../../../api/roomRequisitionApi";
import { getOU } from "../../../api/ouApi";
import { getDepartment } from "../../../api/deptApi";
import { getESSEmployee } from "../../../api/employeeApi";
import RoomReqAdminForm from "../../forms/AdminPortal/RoomReqAdminForm";
import { useLocation } from "react-router-dom";

export default function RoomReqAdminPage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [allRoomReqDS, setAllRoomReqDS] = useState([]);
  const [filteredRoomReqDS, setFilteredRoomReqDS] = useState([]);
  const [form] = Form.useForm();
  const location = useLocation();   //remain filter values when close input form
  const [currentYear, setCurrentYear] = useState(
    location.state ? location.state.filterYear : dayjs().year()
  );
  const [currentMonth, setCurrentMonth] = useState(
    location.state ? location.state.filterMonth : dayjs().month() + 1
  );
  const [allOUs, setAllOUs] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [initialUsers, setInitialUsers] = useState([]);
  const [ouKey, setOUKey] = useState(
    location.state ? location.state.filterOUKey : 0
  );
  const [deptKey, setDeptKey] = useState(
    location.state ? location.state.filterDeptKey : 0
  );
  const [userKey, setUserKey] = useState(
    location.state ? location.state.filterUserKey : 0
  );
  const [pagination, setPagination] = useState(
    {
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });

  useEffect(getRoomReqs, []);

  function getRoomReqs() {
    let promises = [
      getRoomReqDataSource(currentYear, currentMonth),
      getOU(),
      getDepartment(),
      getESSEmployee(),
    ];

    Promise.all(promises).then((values) => {
      resetPagination();

      setAllOUs(values[1] ? values[1].filter((x) => x.Active) : []);
      setAllDepartments(values[2] ? values[2].filter((x) => x.Active) : []);
      setAllUsers(values[3] ? values[3] : []);
      setInitialUsers(values[3] ? values[3] : []);
      setIsLoading(false);
    })
    .catch((error) => {
      setIsLoading(false);
      setAllRoomReqDS([]);
      setFilteredRoomReqDS([]);
      setAllOUs([]);
      setAllDepartments([]);
      setAllUsers([]);
      setInitialUsers([]);
      showErrorMessage(
        t('general.fail_to_load_record') + 
          error.response.data.error_description
      );
    });
  }

  function getRoomReqDataSource(currentYear, currentMonth) {
    setIsLoading(true);
    const CancelToken = Axios.CancelToken;
    const source = CancelToken.source();

    getRoomRequisitions(source, currentYear, currentMonth, true)
      .then((result) => {
        setAllRoomReqDS(result);
        setFilteredRoomReqDS(
          result.filter(
            (x) => 
              (ouKey === 0 || x.OUKey === ouKey) &&
              (deptKey === 0 || x.DeptKey === deptKey) &&
              (userKey === 0 || x.UserKey === userKey)
            )
        );

        setIsLoading(false);
      }).catch((error) => {
        setIsLoading(false);
        setAllRoomReqDS([]);
        setFilteredRoomReqDS([]);
        showErrorMessage(
          t('general.fail_to_load_record') + 
            error.response.data.error_description
        );
      });
  }

  function onViewRoomReq(roomRequisitionKey) {
    history("/home/meetingroomrequisition/roomtrans/" + roomRequisitionKey,
    { state: { 
      fromAdmin: true,
      filterOUKey: ouKey,
      filterDeptKey: deptKey,
      filterUserKey: userKey,
      filterYear: currentYear,
      filterMonth: currentMonth,
    }});
  }

  function filterRecord(ouKey, deptKey, userKey) {
    setOUKey(ouKey);
    setDeptKey(deptKey);
    setUserKey(userKey);
    setFilteredRoomReqDS(
      allRoomReqDS.filter(
        (x) => 
          (ouKey === 0 || x.OUKey === ouKey) &&
          (deptKey === 0 || x.DeptKey === deptKey) &&
          (userKey === 0 || x.UserKey === userKey)
        )
    );
  }

  function showErrorMessage(message) {
    toast.error(message);
  }

  function resetPagination() {
    setPagination({
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });
  }

  return (
    <RoomReqAdminForm 
      isLoading={isLoading}
      roomReqDS={filteredRoomReqDS}
      getRoomReqDataSource={getRoomReqDataSource}
      form={form}
      onViewRoomReq={onViewRoomReq}
      setCurrentYear={setCurrentYear}
      setCurrentMonth={setCurrentMonth}
      allOUs={allOUs}
      allDepartments={allDepartments}
      allUsers={allUsers}
      initialUsers={initialUsers}
      setAllUsers={setAllUsers}
      ouKey={ouKey}
      deptKey={deptKey}
      userKey={userKey}
      currentYear={currentYear}
      currentMonth={currentMonth}
      filterRecord={filterRecord}
      pagination={pagination}
      setPagination={setPagination}
      resetPagination={resetPagination}
    />
  );
}

RoomReqAdminPage.propTypes = {
  history: PropTypes.func.isRequired,
};  